import React from "react";
import "./services.css";

import consultoria from "../../assets/images/consultoria_icone.png";
import cftv from "../../assets/images/CFTV_icone.png";
import administracaoServidores from "../../assets/images/administacao_servidores_icone.png";
import suporteTecnico from "../../assets/images/suporte_icone.png";
import infraestruturaTI from "../../assets/images/infraestrutura-TI.png";
import manutencaoComputadores from "../../assets/images/manutencaocomputadores.png";

const serviceHighlights = [
  {
    value: "+20",
    label: "especialistas certificados",
  },
  {
    value: "24/7",
    label: "monitoramento contínuo",
  },
  {
    value: "100%",
    label: "projetos com SLA dedicado",
  },
];

const servicesList = [
  {
    icon: consultoria,
    alt: "Ícone consultoria em TI",
    title: "Consultoria em TI e Infraestrutura",
    description:
      "Avaliamos ambientes, definimos arquiteturas e conduzimos implementações completas com planos de contingência e governança.",
    items: [
      "Desenho de roadmaps tecnológicos",
      "Políticas de backup e recuperação",
      "Segurança e compliance contínuos",
    ],
  },
  {
    icon: cftv,
    alt: "Ícone infraestrutura CFTV",
    title: "Infraestrutura CFTV",
    description:
      "Projetamos e instalamos sistemas de vigilância inteligentes, integrados a sensores, controle de acesso e monitoramento centralizado.",
    items: [
      "Câmeras inteligentes e analíticas",
      "Alarmes, sensores e fechaduras",
      "Controle de acesso integrado",
    ],
  },
  {
    icon: administracaoServidores,
    alt: "Ícone administração de servidores",
    title: "Administração de Servidores",
    description:
      "Gestão completa de ambientes on-premise e cloud com monitoramento, otimização e respostas proativas a incidentes.",
    items: [
      "Configuração e hardening de servidores",
      "Gestão de usuários e permissões",
      "Automação de rotinas críticas",
    ],
  },
  {
    icon: suporteTecnico,
    alt: "Ícone suporte técnico",
    title: "Suporte Técnico",
    description:
      "Estruturamos atendimento presencial e remoto para manter a operação estável, com SLA sob medida e relatórios transparentes.",
    items: [
      "Service desk multicanal 24/7",
      "Gestão de redes corporativas",
      "Planos personalizados por unidade",
    ],
  },
  {
    icon: infraestruturaTI,
    alt: "Ícone infraestrutura de TI",
    title: "Infraestrutura de TI",
    description:
      "Da conectividade à segurança, cuidamos de toda a base tecnológica para suportar crescimento e novos serviços.",
    items: [
      "Redes cabeadas e Wi-Fi de alta densidade",
      "Data centers, storage e virtualização",
      "Segurança perimetral e zero trust",
    ],
  },
  {
    icon: manutencaoComputadores,
    alt: "Ícone manutenção de computadores",
    title: "Manutenção de Computadores",
    description:
      "Diagnóstico, reparo e otimização de dispositivos para garantir produtividade e longevidade do parque tecnológico.",
    items: [
      "Reparo e upgrade de hardware",
      "Ajustes de software e antivírus",
      "Otimização de desempenho contínua",
    ],
  },
];

function Services() {
  return (
    <section className="services page-section" id="services">
      <div className="section-container">
        <div className="services__intro surface-card">
          <div className="services__intro-text">
            <span className="chip">O que fazemos</span>
            <h2>Serviços completos para sustentar operações críticas</h2>
            <p>
              Atuamos em todas as camadas da infraestrutura de TI com times especializados, metodologias ágeis e foco em
              disponibilidade. Da consultoria ao suporte, entregamos jornadas end-to-end com alto padrão de qualidade.
            </p>
            <div className="services__intro-actions">
              <a className="primary-button" href="#contact">
                Agende uma conversa
              </a>
              <a className="services__intro-ghost" href="#about">
                Conheça nossa história
              </a>
            </div>
          </div>
          <div className="services__intro-meta">
            <div className="services__intro-badge">
              <span>Especialistas em ambientes corporativos</span>
              <p>
                Integramos arquitetura, segurança e suporte contínuo para garantir disponibilidade, escalabilidade e
                previsibilidade de custos.
              </p>
            </div>
            <div className="services__metrics">
              {serviceHighlights.map(({ value, label }) => (
                <div className="services__metric" key={label}>
                  <span className="services__metric-value">{value}</span>
                  <span className="services__metric-label">{label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="services__grid">
          {servicesList.map(({ icon, alt, title, description, items }) => (
            <article className="service-card" key={title}>
              <div className="service-card__header">
                <span className="service-card__icon">
                  <img src={icon} alt={alt} />
                </span>
                <h3>{title}</h3>
              </div>
              <p>{description}</p>
              <ul>
                {items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
